dealershipModule.controller('ProfitSettingsController',
    [ '$scope', '$rootScope', 'ProfitSetting', 'profitSettingsService', 'ProfitSettingTypes', '$q','dealershipModuleConstants','TLCError','AppErrorCodes',
        function ($scope, $rootScope, ProfitSetting, profitSettingsService, ProfitSettingTypes, $q, dealershipModuleConstants, TLCError,AppErrorCodes) {

    // This are passed in via directive attributes: $scope.product

    $scope.profitSetting = new ProfitSetting();
    $scope.originalProfitSetting = angular.copy($scope.profitSetting);

    $scope.profitTypes =  ProfitSettingTypes; // // constants, expose for logic in HTML
    $scope.loading = false;
    $scope.lockedStateRegulated = false;
    $scope.overrideProfitTypes =  [
        ProfitSettingTypes.Flat,
        ProfitSettingTypes.Percentage,
        ProfitSettingTypes.Fixed
    ]; // // constants, expose for logic in HTML
    $scope.sellingPriceOverride = false;

    this.init = function() {
        this.getProfitSetting($scope.product.productCode);
    };

    var saveProfitSetting = function() {
        if ($scope.promiseSave) {
            $scope.promiseSave.resolve();
        }

        if (!$scope.sellingPriceOverride) {
            $scope.profitSetting._vehicleOverridePurchasePrice = 0;
            $scope.profitSetting._vehicleOverrideEnabled = false;
            $scope.profitSetting._vehicleOverrideType = ProfitSettingTypes.Flat;
            $scope.profitSetting._vehicleOverrideProfitAmount = 0;
            $scope.profitSetting._vehicleOverridePercentToCostCap = 0;
            $scope.profitSetting._vehicleOverridePercent = 0;
            $scope.profitSetting._vehicleOverrideMaxProfit = 0;
            $scope.profitSetting._vehicleOverrideRetailAmount = 0;
        }

         if (angular.equals($scope.profitSetting, $scope.originalProfitSetting)) {
            return;
        }

        profitSettingsService.setProfitSetting($scope.product.productCode, Date.today(), $scope.profitSetting)
            .then(function(resultSuccess) {
                if(resultSuccess) {
                    $rootScope.$broadcast(dealershipModuleConstants.RERATE_PRODUCT, {productId: $scope.product.productCode});
                }
            }, function(rejectionReason) {
                if(rejectionReason) {
                    throw new TLCError(new Error(rejectionReason),AppErrorCodes.ProfitSettingController_SaveError);
                }
            });
    };

    $scope.saveProfitSetting = saveProfitSetting;

    $scope.$on('productSettingsSave', function() {
        saveProfitSetting();
    });

    this.getProfitSetting = function(productCode) {
        $scope.loading = true;
        profitSettingsService.getProfitSetting(productCode, Date.today())
            .then(function (result) {
                $scope.loading = false;
                $scope.profitSetting = result;
                $scope.originalProfitSetting = angular.copy(result);
                $scope.lockedStateRegulated = result.type == 'StateRegulated';
                $scope.sellingPriceOverride = result._vehicleOverridePurchasePrice > 0;
                $rootScope.$broadcast('profitSettingsComplete');
            }, function(err) {
                $scope.loading = false;
                throw new TLCError(new Error(err),AppErrorCodes.ProfitSettingController_GeneralError);
            });
    };

    this.init();

}]);


dealershipModule.controller('ProfitSettingsTestController', [ '$scope', function($scope) {
        $scope.products = [{name: 'GAP'}, {name: 'VSC'}];
}]);


